import { Box } from "@chakra-ui/react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import SettingsSidebar from "./components/settingsSidebar";
import { useAppSelector } from "../../store/hooks";

export default function SettingsLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAppSelector((state) => state.auth);
  const isAdmin = user?.role === "admin";

  const getActiveMenu = () => {
    const path = location.pathname;
    if (path.includes("/settings/users")) return "users";
    if (path.includes("/settings/password")) return "password";
    return "general";
  };

  const [activeMenu, setActiveMenu] = useState(() => getActiveMenu());

  useEffect(() => {
    const path = location.pathname;

    if (!isAdmin && path.includes("/settings/users")) {
      setActiveMenu("password");
      navigate("/settings/password", { replace: true });
      return;
    }

    if (path === "/settings") {
      const defaultMenu = isAdmin ? "users" : "password";
      setActiveMenu(defaultMenu);
      navigate(`/settings/${defaultMenu}`, { replace: true });
      return;
    }

    setActiveMenu(getActiveMenu());
  }, [isAdmin, location.pathname, navigate]);

  const handleMenuClick = (menuId: string) => {
    if (!isAdmin && menuId === "users") {
      navigate("/settings/password", { replace: true });
      return;
    }

    setActiveMenu(menuId);
    navigate(`/settings/${menuId}`);
  };

  return (
    <Box
      minH="100vh"
      bg="gray.50"
      className="grid grid-cols-1 md:grid-cols-3 gap-8">
      <SettingsSidebar activeMenu={activeMenu} onMenuClick={handleMenuClick} />
      <Box className="col-span-full md:col-span-2 w-full">
        <Outlet />
      </Box>
    </Box>
  );
}
